import 'intersection-observer'
import { track } from './send'

IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100

export default class Exposure {
  constructor (maxNum = 20) {
    this.cacheDataArr = []
    this.maxNum = maxNum
    // this._timer = 0;
    this._observer = null
    this.init()
  }

  init () {
    const self = this
    this.trackFromLocalStorage()
    this.beforeLeaveWebview()
    this._observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // clearInterval(this._timer);
            const tp = entry.target.trackParams
            self.cacheDataArr.push(tp)
            self._observer.unobserve(entry.target)
            // if (self.cacheDataArr.length >= self.maxNum) {
            self.track()
            // } else {
            //   self.storeIntoLocalStorage(self.cacheDataArr);
            //   if (self.cacheDataArr.length > 0) {
            //     self._timer = setInterval(function () {
            //       self.track();
            //     }, 2000);
            //   }
            // }
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
    )
  }

  add (entry) {
    this._observer && this._observer.observe(entry.el)
  }

  update () {
    console.log('update')
  }

  track () {
    const trackData = this.cacheDataArr.splice(0, this.maxNum)
    track(trackData)
    this.storeIntoLocalStorage(this.cacheDataArr)
  }

  storeIntoLocalStorage (data) {
    window.localStorage.setItem('exposureTrackData', data)
  }

  trackFromLocalStorage () {
    const cacheData = window.localStorage.getItem('exposureTrackData')
    if (cacheData) {
      track(cacheData)
    }
  }

  beforeLeaveWebview () {
    console.log('beforeLeaveWebview')
  }
}
